import { Box, withStyles } from '@material-ui/core';

export const DateWrapper = withStyles({
  root: {
    gridGap: 8,
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    borderRadius: '12px !important',

    '& .rs-pciker': {
      borderRadius: '12px !important'
    },

    '& .rs-picker-input-group': {
      borderRadius: '12px !important'
    },

    '& .sdate-disabled  > .rs-input-group-inside': {
      border: '1px solid #E8ECEE !important'
    },

    '& .rs-picker-toggle-value': {
      color: '#44444F !important'
    },

    '& .rs-picker-disabled .rs-picker-toggle': {
      backgroundColor: '#f2eeee !important'
    },

    '& .sdate-disabled div': {
      backgroundColor: '#EEF0F2 !important'
    },

    '& .sdate-disabled input': {
      backgroundColor: '#EEF0F2 !important',
      color: '#B3B3B3 !important'
    },

    '& .sdate-error > .rs-input-group-inside': {
      border: '1px solid #FA2020 !important'
    }
  }
})(Box);
